(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsd-store-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tsd-navigation')) {
  customElements.define('tsd-navigation', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.initialize());
    }
    disconnectedCallback() {
      this.closeMobile(false);
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggleButton = this.querySelector('.tsn-toggle');
      this.navigation = this.querySelector('.tsn-navigation');
      this.groups = Array.from(this.querySelectorAll('.tsn-group'));
      this.mobile = window.matchMedia('(max-width: 1050px)');
      if (!this.toggleButton || !this.navigation) return;
      this.classList.add('tsn-enhanced');
      this.toggleButton.hidden = false;
      this.toggleButton.addEventListener('click', event => {
        if (this.hasAttribute('data-menu-open')) this.closeMobile(true);
        else this.openMobile(event.detail === 0);
      }, options);
      this.groups.forEach(group => {
        group.addEventListener('toggle', () => {
          if (group.open) this.groups.forEach(other => { if (other !== group) other.open = false; });
        }, options);
        group.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.mobile.matches && !group.contains(document.activeElement)) group.open = false;
          });
        }, options);
      });
      this.navigation.addEventListener('click', event => {
        if (!event.target.closest('a')) return;
        this.closeMobile(false);
        this.groups.forEach(group => { group.open = false; });
      }, options);
      this.querySelector('.tsn-cart')?.addEventListener('click', () => this.closeMobile(false), options);
      this.addEventListener('keydown', event => this.onKeydown(event), options);
      document.addEventListener('click', event => {
        if (this.contains(event.target)) return;
        this.closeMobile(false);
        this.groups.forEach(group => { group.open = false; });
      }, options);
      this.mobile.addEventListener('change', () => {
        this.closeMobile(false);
        this.groups.forEach(group => { group.open = false; });
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.querySelector('.tsn-row'));
      window.addEventListener('hashchange', () => this.markCurrent(), options);
      window.addEventListener('pageshow', () => this.closeMobile(false), options);
      this.measure();
      this.markCurrent();
    }
    measure() {
      this.style.setProperty('--tsn-menu-top', Math.max(0, this.getBoundingClientRect().bottom) + 'px');
    }
    openMobile(focusSearch) {
      if (!this.mobile.matches) return;
      this.measure();
      this.setAttribute('data-menu-open', '');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.toggleButton.setAttribute('aria-label', this.dataset.closeLabel);
      document.body.classList.add('tsn-menu-open');
      this.inertNodes = [];
      let branch = this;
      while (branch.parentElement && branch !== document.body) {
        for (const sibling of branch.parentElement.children) {
          if (sibling === branch || /^(SCRIPT|STYLE|LINK|META)$/.test(sibling.tagName)) continue;
          if (!sibling.inert) { sibling.inert = true; this.inertNodes.push(sibling); }
        }
        branch = branch.parentElement;
      }
      if (focusSearch) this.navigation.querySelector('input[type=search]')?.focus({ preventScroll: true });
    }
    restoreBackground() {
      this.inertNodes?.forEach(node => { node.inert = false; });
      this.inertNodes = [];
    }
    closeMobile(restoreFocus) {
      const wasOpen = this.hasAttribute('data-menu-open');
      this.removeAttribute('data-menu-open');
      this.toggleButton?.setAttribute('aria-expanded', 'false');
      this.toggleButton?.setAttribute('aria-label', this.dataset.openLabel);
      this.restoreBackground();
      document.body.classList.remove('tsn-menu-open');
      if (wasOpen) this.groups?.forEach(group => { group.open = false; });
      if (wasOpen && restoreFocus) this.toggleButton.focus({ preventScroll: true });
    }
    onKeydown(event) {
      if (event.key === 'Escape') {
        if (this.hasAttribute('data-menu-open')) {
          event.preventDefault();
          this.closeMobile(true);
        } else {
          const group = this.groups.find(item => item.open);
          if (group) {
            event.preventDefault();
            group.open = false;
            group.querySelector('summary').focus();
          }
        }
      }
      if (event.key !== 'Tab' || !this.hasAttribute('data-menu-open')) return;
      const focusable = Array.from(this.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),summary'))
        .filter(node => node.getClientRects().length && !node.closest('[inert]'));
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
    markCurrent() {
      const current = new URL(window.location.href);
      const links = Array.from(this.navigation.querySelectorAll('a[href]'));
      this.groups.forEach(group => group.removeAttribute('data-current'));
      links.forEach(link => link.removeAttribute('aria-current'));
      const candidates = links.map(link => {
        const destination = new URL(link.href, current);
        if (destination.origin !== current.origin || destination.pathname !== current.pathname) return null;
        if (destination.hash && destination.hash !== current.hash) return null;
        for (const [key, value] of destination.searchParams) {
          if (current.searchParams.get(key) !== value) return null;
        }
        return { link, score: 1 + (destination.hash ? 2 : 0) + destination.searchParams.size * 3, hash: destination.hash };
      }).filter(Boolean).sort((a, b) => b.score - a.score);
      if (candidates[0]) {
        candidates[0].link.setAttribute('aria-current', candidates[0].hash ? 'location' : 'page');
        candidates[0].link.closest('.tsn-group')?.setAttribute('data-current', '');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
